const getValue = (string) => (key) => (string.match(new RegExp(`(\\d*)\\s*${key}`)) || [])[1];

export const restoreHeightAnswer = ({ answers }) => {
  const getValueFromAnswer = getValue(answers[0]);
  const cm = getValueFromAnswer('cm');
  const inches = getValueFromAnswer('inches');
  const feet = getValueFromAnswer('feet');

  return { cm, inches, feet };
};

export const restoreAnswer = ({ answers }) => answers;

export const restoreDropdownCheckboxAnswer = ({ answers: [answer] }) => [!!answer];

export const restoreCheckboxAnswer = ({ answers }) => [!!parseInt(answers[0], 10)];

export const restoreDropdownWithPriceAnswer = ({ question, answers }) => {
  const rawAnswer = answers?.[0] || '';

  if (!rawAnswer) return [''];

  const optionName = rawAnswer.split('-')[0].trim();
  const matchedOption = question?.options?.find((option) => option.name === optionName);

  return [matchedOption?.displayName || rawAnswer];
};

/**
 * @description splits the first entry of the array at comma "," but ignores comma with space after ", "
 * @param {Array<String>} answers - array with a string in index 0
 * @returns {Array<String>}
 */
export const restoreMultiSelectAnswer = ({ answers }) => {
  const regexForCommaWithoutSpaceAfter = /,(?=\S)/;
  return answers[0].split(regexForCommaWithoutSpaceAfter);
};
